import { IWindowDimension } from "../types";

const minimalWidth = 1440;
// const minimalHeight = 810;
//
const innerWidth = window.outerWidth;
const innerHeight = window.outerHeight;

//
// const factorWidth = minimalWidth / innerWidth;
// const factorHeight = minimalHeight / innerHeight;
//
// // document.querySelector("meta[name=viewport]")?.setAttribute("content", `width=device-width, initial-scale=${ 1 / window.devicePixelRatio }`);
//
// console.log({ factorWidth, factorHeight });
// console.log({ innerWidth, innerHeight });


export const setDimension = (): void => {
  if (innerWidth < minimalWidth) {
    const siteWidth = 1920;
    const scale = innerWidth /siteWidth;

    document.querySelector("meta[name=viewport]")?.setAttribute("content", `width=device-width, initial-scale=${ scale }`);
  }
};


export const getDimension = (): IWindowDimension => {
  // if(factorWidth > 1 || factorHeight > 1) {
  //   if (factorWidth >= factorHeight) {
  //     return {
  //       factor: factorWidth - 1,
  //       width: innerWidth * factorWidth,
  //       height: innerHeight * factorWidth
  //     };
  //   }
  //
  //   return {
  //     factor: factorHeight - 1,
  //     width: innerWidth * factorHeight,
  //     height: innerHeight * factorHeight
  //   };
  // }

  return {
    factor: 1.0,
    width: innerWidth,
    height: innerHeight
  };
};